(function () {
  var settings = window.MA_SETTINGS || {};
  if (!settings.demoLinks) return;

  var OPEN = ['/collections', '/products', '/pages/about'];
  var EXACT = ['/', '/search', '/cart'];

  function allowed(link) {
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return true;
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return true;
    }
    if (url.origin !== window.location.origin) return false;
    var path = url.pathname.replace(/\/+$/, '') || '/';
    if (EXACT.indexOf(path) > -1) return true;
    for (var i = 0; i < OPEN.length; i++) {
      if (path === OPEN[i] || path.indexOf(OPEN[i] + '/') === 0) return true;
    }
    return false;
  }

  function close(link) {
    link.setAttribute('href', '#');
    link.removeAttribute('target');
  }

  function scrub(node) {
    if (node.matches && node.matches('a[href]') && !allowed(node)) close(node);
    if (!node.querySelectorAll) return;
    node.querySelectorAll('a[href]').forEach(function (link) {
      if (!allowed(link)) close(link);
    });
  }

  function start() {
    scrub(document.body);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scrub(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
